module.exports = __webpack_public_path__ + "static/media/logo.4d4c9051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 52
// module chunks = 0